import { useEffect } from 'react'
import type { ThemeMode } from '../types'

export function useTheme(themeMode: ThemeMode) {
  useEffect(() => {
    const root = document.documentElement

    if (themeMode === 'system') {
      const mq = window.matchMedia('(prefers-color-scheme: dark)')
      const apply = () => {
        if (mq.matches) {
          root.classList.add('dark')
        } else {
          root.classList.remove('dark')
        }
      }
      apply()
      mq.addEventListener('change', apply)
      return () => mq.removeEventListener('change', apply)
    }

    if (themeMode === 'dark') {
      root.classList.add('dark')
    } else {
      root.classList.remove('dark')
    }
  }, [themeMode])
}
